import { render, staticRenderFns } from "./TableThumb.vue?vue&type=template&id=5fd1e1e1&scoped=true"
import script from "./TableThumb.vue?vue&type=script&lang=js"
export * from "./TableThumb.vue?vue&type=script&lang=js"
import style0 from "./TableThumb.vue?vue&type=style&index=0&id=5fd1e1e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd1e1e1",
  null
  
)

export default component.exports